// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FRQC","controls":"styles_controls__3GjBF","charLimit":"styles_charLimit__KC_GY","input":"styles_input__wsaRk","send":"styles_send__1kEqR"};